import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { request } from '../../services/utilities';
import { rosterAPI } from '../../services/constants';

const TeamMenu = ({ department }) => {
	const profile = useSelector(state => state.user.profile);
	const [isHOS, setIsHOS] = useState(false);

	useEffect(() => {
		const checkHOS = async () => {
			try {
				const staffId = profile?.details?.id;
				const deptId = profile?.details?.department?.id;
				if (!staffId || !deptId) return;
				const period = moment().format('YYYY-MM');
				const today = moment().date();
				const hour = moment().hour();
				const currentShift = hour >= 8 && hour < 17 ? 'Morning' : 'Night';
				const uri = `${rosterAPI}/rosters?period=${period}&department_id=${deptId}&staff_id=${staffId}`;
				const rs = await request(uri, 'GET', true);
				if (rs?.length) {
					const schedule = rs[0]?.schedule || [];
					const todayEntry = schedule.find(s => s.schedule_date === today);
					if (todayEntry?.is_hos && todayEntry?.duty === currentShift) {
						setIsHOS(true);
					}
				}
			} catch (e) {
				// silently fail
			}
		};
		checkHOS();
	}, [profile]);

	const role = profile?.role?.slug;
	const isItAdmin = role === 'it-admin';
	const isDoctorNurse = role === 'doctor' || role === 'hmo-doctor' || role === 'nurse';
	const isHOD = !department?.unit;

	const canSeeRoomAssignment = isItAdmin;
	// || (isDoctorNurse && (isHOD || isHOS));

	return (
		<>
			<li>
				<Link to="/team/roster">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>Team Schedule</span>
				</Link>
			</li>
			{canSeeRoomAssignment && (
				<li>
					<Link to="/team/room-assignment">
						<div className="icon-w">
							<div className="os-icon os-icon-home" />
						</div>
						<span>Room Assignment</span>
					</Link>
				</li>
			)}

			{!department.unit && (
				<>
					<li>
						<Link to="/team/units">
							<div className="icon-w">
								<div className="fa fa-users" />
							</div>
							<span>Team Units</span>
						</Link>
					</li>

					<li>
						<Link to="/team/team-attendance">
							<div className="icon-w">
								<div className="fa fa-users" />
							</div>
							<span>Team Attendance</span>
						</Link>
					</li>
					<li>
						<Link to="/team/leave-applications">
							<div className="icon-w">
								<div className="fa fa-users" />
							</div>
							<span>Team Leave Mgt.</span>
						</Link>
					</li>
					<li>
						<Link to="/team/appraisals">
							<div className="icon-w">
								<div className="fa fa-users" />
							</div>
							<span>Team Appraisals</span>
						</Link>
					</li>
					<li>
						<Link to="/team/appraisal-creator">
							<div className="icon-w">
								<div className="fa fa-users" />
							</div>
							<span>Team Appraisal Creator</span>
						</Link>
					</li>
				</>
			)}
		</>
	);
};

export default TeamMenu;
